module.exports = __webpack_public_path__ + "img/rectangle-fill-black.4f502c2a.svg";